<template>
  <div class="pad-fill-profile chart-content">
    <div class="pad-fill-profile-wrapper">
      <div ref="print" class="page-card-wrapper">
        <div class="page-card-title">
          <div
            class="left-side-text"
            v-if="$store.state.patient.selectedPatient"
          >
            {{ $store.state.patient.selectedPatient.alias }}
            <span v-if="$store.state.patient.selectedPatient.podMac"
              >({{
                $store.state.patient.selectedPatient.podMac.substr(-4)
              }})</span
            >
          </div>
          <span class="page-card-title-text">{{
            $t('text.pad_fill_profile', {
              pad: $firstLetterCapitalize($store.state.locale.pad)
            })
          }}</span>
          <DateRangePicker />
        </div>
        <div class="page-card-content">
          <div v-if="loading" class="loading-chart-wrapper">
            <LoadingAnimation />
          </div>
          <div class="mt-15 volume-char-wrapper" v-else>
            <div class="card-wrapper left-card">
              <div
                class="mt-30 text-center black-big-font bold-font v-h-center inline-flex title"
              >
                <div class="refresh-wrapper" v-if="selectedMode === 'total'">
                  <img src="../../assets/image/refresh-blue.svg" />
                  <span class="refresh-text">24h</span>
                </div>
                <img
                  v-if="selectedMode === 'day'"
                  class="w-46 mr-10"
                  src="../../assets/image/morning_icon.png"
                />
                <img
                  v-if="selectedMode === 'night'"
                  class="w-46 mr-10"
                  src="../../assets/image/night_Icon.png"
                />
                {{ getTitle() }}
              </div>
              <div class="profile-item-wrapper">
                <div
                  v-for="(item, index) in getProfileArr()"
                  :key="index"
                  class="profile-item"
                >
                  <div v-if="item.Flag !== padFillProfileType.placeholder">
                    <div :class="{ 'light-red-area': item.Red }" class="pt-10">
                      <div
                        v-if="item.Flag !== padFillProfileType.insufficientData"
                        class="volume-info"
                      >
                        <span class="emphasize-font">{{ item.Volume }}</span>
                        <span>ml</span>
                        <span
                          class="check-pad-fill-profile-icon ml-5"
                          v-if="item.Red"
                        >
                          <img
                            class="w-15"
                            src="../../assets/image/check-pad-fill-profile-icon.jpg"
                          />
                        </span>
                      </div>
                      <div class="volume-info" v-else>
                        {{ $t('text.insufficient_data') }}
                      </div>
                      <img
                        class="wp-56 mb-20"
                        :src="
                          require('../../assets/image/WaterDropIcons/' +
                            getProfileImg(item.Volume))
                        "
                      />
                    </div>
                    <div class="mb-5 emphasize-font mt-10">
                      {{
                        $t('text.' + item.WeekNumber) | firstLetterCapitalize
                      }}
                    </div>
                    <div>{{ item.Date }}</div>
                  </div>
                  <div v-else class="placeholder-circle"></div>
                </div>
              </div>
            </div>
            <div class="card-wrapper right-card">
              <div class="mt-30 text-center black-big-font bold-font title">
                {{ $t('text.average') | firstLetterCapitalize }}
              </div>
              <div class="profile-item">
                <div class="mt-15 volume-info">
                  <span class="emphasize-font">{{ getAvgData() }}</span>
                  <span>ml</span>
                </div>
                <img
                  class="wp-56 mb-20"
                  :src="
                    require('../../assets/image/WaterDropIcons/' +
                      getProfileImg(getAvgData()))
                  "
                />
                <div class="mb-5 emphasize-font mt-10">
                  {{ getLastDaysTitle() }}
                </div>
                <div>
                  {{
                    userLang.indexOf('en') > -1
                      ? moment(
                          $store.state.patient.selectedDateRange[1]
                        ).format('DD MMM YY ')
                      : moment(
                          $store.state.patient.selectedDateRange[1]
                        ).format('DD/MM/YY ')
                  }}
                </div>
              </div>
            </div>
            <div class="clear-both"></div>
          </div>
          <div class="time-location-text">
            {{ $t('text.all_times_are_in') }} {{ location || '--' }}
          </div>
          <div class="bottom-section-wrapper">
            <div class="left-side">
              <div class="mode">
                <div class="mode-label">
                  {{ $t('text.view') | firstLetterCapitalize }}
                </div>
                <b-form-radio-group v-model="selectedMode">
                  <b-form-radio
                    v-for="(item, index) in modes"
                    :key="index"
                    :value="item.value"
                  >
                    {{ $t('text.' + item.text) }}
                  </b-form-radio>
                </b-form-radio-group>
              </div>
              <div class="mt-20">
                <span class="mr-10">{{
                  $t('text.pad_fill_profile_goal', {
                    pad: $store.state.locale.pad
                  }).toUpperCase()
                }}</span>
                <div class="show-mobile mb-5"></div>
                <span
                  class="goal-btn"
                  :class="
                    goalEnabled
                      ? 'blackish-green-bg white-font'
                      : 'light-grey-bg dark-grey-font'
                  "
                  >{{ goalEnabled ? $t('text.on') : $t('text.off') }}</span
                >
                <span
                  class="blue-font pointer"
                  @click="toPadFillProfileGoals()"
                  v-if="p('Patients.Goals.FillProfile.View')"
                  >({{
                    $t('text.tap_to_setup_pad_fill_profile_goals', {
                      pad: $store.state.locale.pad
                    })
                  }})</span
                >
              </div>
            </div>
            <div class="right-side">
              <!-- <span>{{ $t('text.legend') }}</span>
              <span class="check-pad-fill-profile-icon ml-10">
                <img
                  class="w-15"
                  src="../../assets/image/check-pad-fill-profile-icon.jpg"
                />
              </span>
              <span class="ml-10">{{
                $t('text.check_pad_fill_profile').toLowerCase()
              }}</span> -->

              <div
                class="check-pad-fill-profile-row light-red-bg v-h-center"
                v-if="goalEnabled"
              >
                <div class="image-wrapper v-h-center inline-flex">
                  <img
                    class="w-30"
                    style="margin-top: -3px"
                    src="../../assets/image/check-pad-fill-profile-icon.jpg"
                  />
                </div>
                <div class="inline-block text-wrapper">
                  <div>
                    {{
                      $t('text.check_pad_fill_profile', {
                        pad: this.$store.state.locale.pad
                      }).toUpperCase()
                    }}
                  </div>
                  <div class="goal-text">
                    {{ $t('text.goal').toUpperCase() }}
                  </div>
                  <div>
                    <span class="mr-20"
                      >{{ $t('text.day').toLowerCase() }}:
                      {{
                        padFillGoal.DayVolGoal
                          ? padFillGoal.DayVolGoal + 'ml'
                          : '-'
                      }}</span
                    >
                    <span
                      >{{ $t('text.night').toLowerCase() }}:
                      {{
                        padFillGoal.NightVolGoal
                          ? padFillGoal.NightVolGoal + 'ml'
                          : '-'
                      }}</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="clear-both"></div>
        </div>
      </div>
      <div class="action-btns mt-20">
        <div
          class="action-btn"
          @click="share()"
          v-if="p('Patients.Charts.FillProfile.Share')"
        >
          <svg-icon
            iconClass="share"
            class="w-15 mr-10"
            className="white-font"
          ></svg-icon>
          <span>{{ $t('text.share') }}</span>
        </div>
        <div
          class="action-btn"
          @click="print()"
          v-if="p('Patients.Charts.FillProfile.Print')"
        >
          <svg-icon
            iconClass="report"
            class="w-15 mr-10"
            className="white-font"
          ></svg-icon>
          <span>{{ $t('text.print') }}</span>
        </div>
      </div>
    </div>
    <ShareDialog ref="shareDialog" />
  </div>
</template>

<script>
import $ from 'jquery'
import LoadingAnimation from '@/components/patients/charts/LoadingAnimation'
import moment from 'moment'
import ApiService from '@/services/ApiService.js'
import ShareDialog from '@/components/patients/charts/ShareDialog'
import { images, padFillProfileType } from '@/const.js'
import DateRangePicker from '@/components/patients/charts/DateRangePicker'
import html2canvas from 'html2canvas'
import printJS from 'print-js'
import swal from 'sweetalert'
export default {
  name: 'pad-fill-profile',
  data() {
    return {
      moment,
      padFillProfileType,
      userLang: navigator.language || navigator.userLanguage,
      loading: false,
      images: images,
      dataArr: [],
      modes: [
        {
          text: 'total_daily_profile',
          value: 'total'
        },
        {
          text: 'day_profile',
          value: 'day'
        },
        {
          text: 'night_profile',
          value: 'night'
        }
      ],
      selectedMode: 'total',
      goalEnabled: false,
      location: null,
      padFillGoal: {}
    }
  },
  components: {
    DateRangePicker,
    ShareDialog,
    LoadingAnimation
  },
  computed: {
    subject() {
      return this.$t('text.pad_fill_profile', {
        pad: this.$firstLetterCapitalize(this.$store.state.locale.pad)
      })
    },
    getProfileArr() {
      return () => {
        let arr
        switch (this.selectedMode) {
          case 'total':
            arr = this.dataArr.map(item => {
              return item.Flag !== padFillProfileType.placeholder
                ? {
                    ...item,
                    Volume: item.DayVolume + item.NightVolume,
                    Red: [
                      padFillProfileType.dayRed,
                      padFillProfileType.nightRed,
                      padFillProfileType.bothRed
                    ].includes(item.Flag)
                  }
                : item
            })
            break
          case 'day':
            arr = this.dataArr.map(item => {
              return item.Flag !== padFillProfileType.placeholder
                ? {
                    ...item,
                    Volume: item.DayVolume,
                    Red: [
                      padFillProfileType.dayRed,
                      padFillProfileType.bothRed
                    ].includes(item.Flag)
                  }
                : item
            })
            break
          case 'night':
            arr = this.dataArr.map(item => {
              return item.Flag !== padFillProfileType.placeholder
                ? {
                    ...item,
                    Volume: item.NightVolume,
                    Red: [
                      padFillProfileType.nightRed,
                      padFillProfileType.bothRed
                    ].includes(item.Flag)
                  }
                : item
            })
            break
          default:
            arr = this.dataArr.map(item => {
              return item.Flag !== padFillProfileType.placeholder
                ? {
                    ...item,
                    Volume: item.DayVolume + item.NightVolume,
                    Red: [
                      padFillProfileType.dayRed,
                      padFillProfileType.nightRed,
                      padFillProfileType.bothRed
                    ].includes(item.Flag)
                  }
                : item
            })
        }
        return arr
      }
    },
    getProfileImg() {
      return volume => {
        let imgUrl
        if (volume < 0) {
          imgUrl = 'water-droplet-0.png'
        } else if (volume === 0) {
          imgUrl = 'water-droplet-1.png'
        } else if (volume > 0 && volume <= 500) {
          imgUrl = 'water-droplet-3.png'
        } else if (volume > 500 && volume <= 1000) {
          imgUrl = 'water-droplet-5.png'
        } else if (volume > 1000 && volume <= 1500) {
          imgUrl = 'water-droplet-7.png'
        } else if (volume > 1500 && volume <= 2000) {
          imgUrl = 'water-droplet-9.png'
        } else if (volume > 2000) {
          imgUrl = 'water-droplet-10.png'
        }
        return imgUrl
      }
    },
    getAvgData() {
      return () => {
        let total = 0
        let count = 0
        this.getProfileArr().forEach(item => {
          if (item.Volume > 0) {
            total = total + item.Volume
            count++
          }
        })
        if (!total || !count) return 0
        let avg = Math.round(total / count)
        return avg
      }
    },
    getTitle() {
      return () => {
        let title = this.modes.filter(item => {
          return item.value === this.selectedMode
        })
        return this.$t('text.' + title[0].text)
      }
    },
    getLastDaysTitle() {
      return function() {
        let language = this.$store.state.locale.currentLocale
        let days =
          moment(this.$store.state.patient.selectedDateRange[1]).diff(
            moment(this.$store.state.patient.selectedDateRange[0]),
            'days'
          ) + 1
        let titleArr = {
          en: `Last ${days} days`,
          it: `Ultimi ${days} giorni`,
          de: `Letzte ${days} Tage`,
          fr: `${days} derniers jours`,
          nl: `Laatste periode van ${days} dagen`
        }
        return titleArr[language]
      }
    }
  },
  mounted: function() {
    this.setTitlePosition()
    this.getData()
    window.addEventListener('resize', () => {
      this.setTitlePosition()
    })
  },
  watch: {
    '$store.state.patient.selectedPatient.patientId': function() {
      this.getData()
    },
    '$store.state.patient.selectedDateRange': function() {
      this.getData()
    },
    '$store.state.locale.currentLocale': function() {
      this.setTitlePosition()
    },
    selectedMode: function() {
      this.setTitlePosition()
    }
  },
  methods: {
    getData: function() {
      if (!this.$store.state.patient.selectedPatient) return false
      this.loading = true
      this.dataArr = []
      ApiService.getPadFillProfile(
        this.$store.state.patient.selectedPatient.patientId,
        moment(this.$store.state.patient.selectedDateRange[0]).format(
          'YYYY-MM-DD'
        ),
        moment(this.$store.state.patient.selectedDateRange[1]).format(
          'YYYY-MM-DD'
        )
      )
        .then(response => {
          this.loading = false
          this.location = response.data.Location

          // get goal status
          this.goalEnabled = response.data.goalEnabled

          // get pad fill goal
          this.padFillGoal = response.data.padFillGoal

          let startDate = moment(
            this.$store.state.patient.selectedDateRange[0]
          ).format('YYYY-MM-DD')
          let endDate = moment(
            this.$store.state.patient.selectedDateRange[1]
          ).format('YYYY-MM-DD')
          let dataArr = response.data.data
            .filter(item => {
              // Filter out data outside the time range selected by the user
              return (
                moment(item.StartDate).isSameOrAfter(startDate) &&
                moment(item.StartDate).isSameOrBefore(endDate)
              )
            })
            .map(item => {
              item.Date =
                this.userLang.indexOf('en') > -1
                  ? moment(item.StartDate).format('DD MMM YY')
                  : moment(item.StartDate).format('DD/MM/YY')
              return {
                ...item,
                WeekNumber: moment(item.StartDate).format('dddd')
              }
            })

          // If the date selected is less than 7 days, show placeholder
          if (dataArr.length < 7) {
            let placeholder = Array(7 - dataArr.length).fill({
              Flag: padFillProfileType.placeholder
            })
            this.dataArr = placeholder.concat(dataArr)
          } else {
            this.dataArr = dataArr
          }
        })
        .catch(() => {
          this.loading = false
          this.dataArr = []
          swal({
            icon: 'error',
            title: this.$t('text.failed'),
            text: this.$t('text.failed_to_get_chart_data')
          })
        })
    },
    setTitlePosition() {
      this.$nextTick(() => {
        if (window.innerWidth >= 800) {
          let titleOffset = $('.title-wrapper .title .title-text').offset()
          if (titleOffset && titleOffset.left) {
            setTimeout(() => {
              $('.left-card .title').offset({
                left: titleOffset.left - 55
              })
            }, 1)
          }
        }
      })
    },
    toPadFillProfileGoals() {
      this.$router.push({
        path: '/patients/pad-fill-profile-goal'
      })
    },
    share() {
      this.$refs.shareDialog.openDialog('pad_fill_profile')
    },
    print() {
      window.pageYoffset = 0
      document.documentElement.scrollTop = 0
      document.body.scrollTop = 0
      let options = {
        backgroundColor: null,
        dpi: window.devicePixelRatio * 2,
        scale: 2,
        removeContainer: false,
        onclone: doc => {
          $(doc)
            .find('body')
            .css('width', '1600px')
          $(doc)
            .find('.new-design .sidebar-type-page-content')
            .css('width', '100%')
          $(doc)
            .find('.new-design .page-card-wrapper')
            .css('max-width', 'unset')
          $(doc)
            .find('.new-design .page-card-wrapper .page-card-content')
            .css('height', 'auto')
          $(doc)
            .find('.new-design .chart-filters .filter-row-wrapper .filter-item')
            .css('display', 'inline-block')
          $(doc)
            .find('.show-mobile')
            .css('display', 'none')
          $(doc)
            .find(
              '.new-design .page-card-wrapper .page-card-title .page-card-title-text'
            )
            .css('margin-top', 0)
          $(doc)
            .find(
              '.new-design .page-card-wrapper .page-card-title .left-side-text'
            )
            .css('display', 'inline-block')
          $(doc)
            .find(
              '.new-design .page-card-wrapper .page-card-title .date-wrapper'
            )
            .css('position', 'absolute')
            .css('top', '6px')
            .css('right', '10px')
          $(doc)
            .find('.el-range-editor .el-range-input')
            .css('line-height', '24px')
          $(doc)
            .find('.pad-fill-profile-wrapper .volume-char-wrapper')
            .css('display', 'flex')
            .css('align-items', 'center')
            .css('justify-content', 'center')
          $(doc)
            .find('.pad-fill-profile-wrapper .left-card')
            .css('width', 'calc(100% * 0.875 - 15px * 0.875)')
          $(doc)
            .find('.pad-fill-profile-wrapper .left-card .profile-item-wrapper')
            .css('width', '100%')
          $(doc)
            .find('.pad-fill-profile-wrapper .right-card')
            .css('width', 'calc(100% * 0.125 - 15px * 0.125)')
            .css('margin-left', '15px')
          $(doc)
            .find('.pad-fill-profile-wrapper .right-card .profile-item')
            .css('width', '100%')
          $(doc)
            .find('.pad-fill-profile-wrapper .right-side')
            .css('float', 'right')
        }
      }
      html2canvas(this.$refs.print, options).then(canvas => {
        const url = canvas.toDataURL()
        printJS({
          printable: url,
          type: 'image'
        })
      })
    }
  }
}
</script>
